// AttendanceTable.jsx - новый компонент для учета посещений
import React, { useState, useEffect, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import { uk } from 'date-fns/locale/uk';
import ChildrenTable from '../TableChildren';

import 'react-datepicker/dist/react-datepicker.css';


import { 
  getAttendanceData, 
  getChildrenInfo, 
  saveAttendance, 
  saveTempAttendance 
} from './actions';

registerLocale('uk', uk);


const isPossible = (periodStartYear)=>{


    const curDate = new Date().toISOString();

    const [c_yy, c_mm, c_dd] = curDate.split("T")[0].split("-").map(r=>+r);
    
    const curPeriod = c_mm > 8 ? c_yy : c_yy - 1;
    
    const correctionStart = new Date(curPeriod, 7, 1); // 1 августа
    const correctionEnd = new Date(curPeriod + 1, 8, 5); // 5 сентября следующего года
    const dateToCheck = new Date(periodStartYear, 8, 5);
    
    if (dateToCheck < correctionStart) return false;
    if (dateToCheck > correctionEnd) return false;

    return true;

}

const AttendanceTable = ({
  kg_id,
  gr_id,
  groups = [],
  onSaveAttendance,
  onGetAttendanceData,
  periodStartYear
}) => {
  const [attendanceData, setAttendanceData] = useState({});
  const [attendanceDataOut, setAttendanceDataOut] = useState([]);
  const [isCorrection, setIsCorrection] = useState(false);
  const [correctionDate, setCorrectionDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  // Проверка доступности даты для корректировки
  const validateCorrectionDate = useCallback((date) => {

    if (!periodStartYear) return false;
    
    const currentYear = periodStartYear;
    const correctionStart = new Date(currentYear, 7, 1); // 1 августа
    const correctionEnd = new Date(currentYear + 1, 8, 5); // 5 сентября следующего года
    const dateToCheck = new Date(date);
    
    if (dateToCheck < correctionStart) return false;
    if (dateToCheck > correctionEnd) return false;
    if (isCorrection && new Date().setHours(9, 0, 0) < dateToCheck.getTime()) return false;
    
    return true;
  }, [periodStartYear, isCorrection]);

  // Загрузка данных посещения
  const loadAttendanceData = useCallback(async () => {
    //if (!onGetAttendanceData) return;
    
    setIsLoading(true);
    try {
      const dateToUse = isCorrection ? correctionDate : new Date();
      //const data = await onGetAttendanceData(gr_id, dateToUse);

      const data = await getAttendanceData(kg_id,gr_id,dateToUse, isCorrection ? "correction" : "day" );

      const info_att = {};

      for(let d of data.data){
        if(!info_att[d.idChild]) info_att[d.idChild] = true
      }

      setAttendanceData(info_att);
      setAttendanceDataOut(data.data.map(r=>{r['checked'] = true; return r}));
    } catch (error) {
      console.error('Error loading attendance data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [gr_id, isCorrection, correctionDate, onGetAttendanceData]);


  const onChildrensList = (data)=>{

    if(!data) return;
    
    setAttendanceDataOut(data.map(r=>{
        r['checked'] = attendanceData[r.idChild] || false;

        return r;
    }));


  }

  // Сохранение данных посещения
  const saveAttendance_ = useCallback(async () => {
    //if (!onSaveAttendance) return;

    try {
      const dateToUse = isCorrection ? correctionDate : new Date();
      
      if (isCorrection && dateToUse >= new Date(new Date().setHours(0, 0, 0, 0))) {
        alert('Коригування даних на поточну або майбутню дату неможливо.');
        return;
      }

      const attenGroupObj = {
        date: dateToUse,
        idKg: kg_id,
        idGr: gr_id,
        period: isCorrection ? 'correction' : 'day',
        child: attendanceDataOut.filter(r=>r.checked).map(r=>({idChild: r.idChild, tPl: r.tPl}))
      };

      await saveAttendance(attenGroupObj)

      if(onSaveAttendance) await onSaveAttendance({
        date: dateToUse,
        childIds: Object.keys(attendanceData).filter(id => attendanceData[id]),
        isCorrection
      });

      alert(`Операція успішна. Зафіксовано відвідування ${Object.keys(attendanceData).filter(id => attendanceData[id]).length} дітей`);
      
      if (isCorrection) {
        // Автоматический переход на следующую дату в режиме корректировки
        const nextDate = new Date(correctionDate);
        nextDate.setDate(nextDate.getDate() + 1);
        if (validateCorrectionDate(nextDate)) {
          setCorrectionDate(nextDate);
        }
      } else {
        // В обычном режиме просто обновляем данные
        loadAttendanceData();
      }
    } catch (error) {
      alert('Виникла помилка при збереженні.');
      console.error('Error saving attendance:', error);
    }
  }, [attendanceData, isCorrection, correctionDate, onSaveAttendance, validateCorrectionDate, loadAttendanceData]);

  // Переключение чекбокса для конкретного ребенка
  const toggleChildAttendance = (child) => {
    const childId = child._id;

    const attData = [...attendanceDataOut];
    const indexOut = attData.findIndex(r=>r.idChild == childId);

    if(indexOut < 0) attData.push({idChild: childId, tPl: child.tPl});

    const curIndex = indexOut < 0 ? attData.length - 1 : indexOut;
        
    attData[curIndex]['checked'] = !attendanceData[childId];
    
    setAttendanceDataOut(attData);

    setAttendanceData(prev => ({
      ...prev,
      [childId]: !prev[childId]
    }));
  };

  // Выделение всех детей
  const selectAllChildren = ()=>{
    const outChecked = {};
    attendanceDataOut.forEach(r=>{
        outChecked[r.idChild] = true;
    });

    setAttendanceData(outChecked);
    setAttendanceDataOut(attendanceDataOut.map(r=>{r.checked = true; return r}));
  }

  // Снятие выделения со всех детей
  const deselectAllChildren = ()=>{
    const outChecked = {};
    attendanceDataOut.forEach(r=>{
        outChecked[r.idChild] = false;
    });

    setAttendanceData(outChecked);
    setAttendanceDataOut(attendanceDataOut.map(r=>{r.checked = false; return r}));
  }

  // Изменение даты корректировки
  const handleDateChange = useCallback((date) => {
    if (validateCorrectionDate(date)) {
      setCorrectionDate(date);
    } else {
      alert('Оберіть дату меншу за поточну або в межах дозволеного періоду');
    }
  }, [validateCorrectionDate]);

  // Переход к предыдущей дате
  const goToPreviousDate = useCallback(() => {
    const prevDate = new Date(correctionDate);
    prevDate.setDate(prevDate.getDate() - 1);
    if (validateCorrectionDate(prevDate)) {
      setCorrectionDate(prevDate);
    }
  }, [correctionDate, validateCorrectionDate]);

  // Переход к следующей дате
  const goToNextDate = useCallback(() => {
    const nextDate = new Date(correctionDate);
    nextDate.setDate(nextDate.getDate() + 1);
    if (validateCorrectionDate(nextDate)) {
      setCorrectionDate(nextDate);
    }
  }, [correctionDate, validateCorrectionDate]);

  // Загрузка данных при изменении режима или даты
  useEffect(() => {
    loadAttendanceData();
  }, [loadAttendanceData]);

  // Конфигурация колонок для таблицы с учетом посещений
  const attendanceColumns = [
    {
      key: 'attendance',
      label: 'Присутність',
      sortable: false,
      width: '10%',
      renderHeader: (column) => (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            onChange={(e) => {
              // Логика для выделения всех будет добавлена через props
            }}
            title={column.label}
          />
        </div>
      ),
      renderCell: (child, column, props) => (
        <input
          type="checkbox"
          checked={!!props.attendanceData[child._id]}
          onChange={() => props.onToggleAttendance(child)}
          className="attendance-checkbox"
        />
      )
    },
    {
      key: 'lastName',
      label: 'Прізвище',
      sortable: true,
      width: '12%'
    },
    {
      key: 'firstName',
      label: "Ім'я",
      sortable: true,
      width: '10%'
    },
    {
      key: 'middleName',
      label: 'По батькові',
      sortable: true,
      width: '12%'
    },
    {
      key: 'birthDate',
      label: 'Дата народження',
      sortable: true,
      width: '10%'
    },
    {
      key: 'documentNumber',
      label: 'Серія та номер свідоцтва про народження',
      sortable: true,
      width: '12%'
    },
    {
      key: 'enrollmentDate',
      label: 'Дата зарахування',
      sortable: true,
      width: '10%'
    },
    {
      key: 'placeType',
      label: 'Тип місця в групі',
      sortable: true,
      width: '10%'
    },
    {
      key: 'foodType',
      label: 'Тип харчування',
      sortable: true,
      width: '12%'
    }
  ];

  const currentGroup = groups.find(g => g._id === gr_id) || {};

  if(!isPossible(periodStartYear)) return(<div><span>Модуль обліку відвідування недоступний для навчального періоду групи</span></div>)

  return (
    <div className="attendance-table-container">
      <div className="attendance-header mb-3">
        <div className="row align-items-center">
          <div className="col-md-8">
            <h5 className="mb-1">Облік відвідування закладу</h5>
            {isCorrection && (
              <p className="text-warning mb-0">
                Увага - включений режим коригування на {correctionDate.toLocaleDateString('uk-UA')}
              </p>
            )}
            <p className="text-muted mb-0">
              Встановіть позначки для дітей, що відвідали садочок {isCorrection ? 'у вибрану дату' : 'сьогодні'}
            </p>
          </div>
          
          <div className="col-md-4">
            <div className="d-flex justify-content-end gap-2">
              {!isCorrection && (
                <button 
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => setIsCorrection(true)}
                >
                  Коригування
                </button>
              )}
              
              {isCorrection && (
                <div className="d-flex align-items-center gap-2">
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToPreviousDate}
                    title="Попередня дата"
                  >
                    ←
                  </button>
                  
                  <DatePicker
                    selected={correctionDate}
                    onChange={handleDateChange}
                    dateFormat="dd.MM.yyyy"
                    locale="uk"
                    className="form-control form-control-sm correction-date"
                    maxDate={new Date()}
                  />
                  
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToNextDate}
                    title="Наступна дата"
                  >
                    →
                  </button>
                  
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => setIsCorrection(false)}
                  >
                    Звичайний режим
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="attendance-controls mb-3">
        <div className="d-flex gap-2">
          <button 
            className="btn btn-outline-primary btn-sm"
            onClick={() => selectAllChildren(currentGroup.children || [])}
          >
            Обрати всіх
          </button>
          <button 
            className="btn btn-outline-secondary btn-sm"
            onClick={deselectAllChildren}
          >
            Зняти всі
          </button>
          <button 
            className="btn btn-primary btn-sm"
            onClick={saveAttendance_}
            disabled={isLoading}
          >
            {isLoading ? 'Збереження...' : (isCorrection ? 'Зберегти коригування' : 'Зафіксувати відвідування')}
          </button>
        </div>
      </div>

      <ChildrenTable
        id={kg_id}
        group_id={gr_id}
        columnsConfig={attendanceColumns}
        onChildrensList={onChildrensList}
        customProps={{
          attendanceData,
          onToggleAttendance: toggleChildAttendance,
          onSelectAll: () => selectAllChildren(currentGroup.children || []),
          onDeselectAll: deselectAllChildren
        }}
      />
    </div>
  );
};

export default AttendanceTable;